<button mat-icon-button class="close-button" (click)="close()">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 matDialogTitle>{{data.title}}</h1>
<div mat-dialog-content>
  <mat-card class="p-0">
    <form [formGroup]="produtoPrecoForm" *ngIf="produtoPrecoForm">
      <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px" class="form-container">
        <!-- Preço -->
        <div fxFlex="100" fxFlex.gt-sm="25" fxFlex.sm="50" fxFlex.xs="100">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Preço</mat-label>
            <input
              matInput
              name="preco"
              type="text"
              step="any"
              (focus)="$event.target.select()"
              [formControl]="produtoPrecoForm.controls['preco']!"
              currencyMask
              [options]="{ prefix: 'R$ ', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }"
            />
          </mat-form-field>
        </div>

        <!-- Percentual de Desconto -->
        <div fxFlex="100" fxFlex.gt-sm="25" fxFlex.sm="50" fxFlex.xs="100">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>(%) Desconto Promocional</mat-label>
            <input
              matInput
              name="percentualDesc"
              type="text"
              step="any"
              (focus)="$event.target.select()"
              [formControl]="produtoPrecoForm.controls['percentualDesc']!"
              currencyMask
              [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 5 }"
            />
          </mat-form-field>
        </div>

        <!-- Preço Promocional -->
        <div fxFlex="100" fxFlex.gt-sm="25" fxFlex.sm="50" fxFlex.xs="100">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Preço Promocional</mat-label>
            <input
              matInput
              name="precoPromocao"
              type="text"
              step="any"
              (focus)="$event.target.select()"
              [formControl]="produtoPrecoForm.controls['precoPromocao']!"
              currencyMask
              [options]="{ prefix: 'R$ ', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }"
            />
          </mat-form-field>
        </div>

        <!-- Validade -->
        <div fxFlex="100" fxFlex.gt-sm="25" fxFlex.sm="50" fxFlex.xs="100">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Validade</mat-label>
            <input
              matInput
              [matDatepicker]="picker"
              [formControl]="produtoPrecoForm.controls['validadePromocao']"
            />
            <mat-hint>DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker startView="month" [startAt]="startDate"></mat-datepicker>
          </mat-form-field>
        </div>

        <!-- Observações -->
        <div fxFlex="100">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Observações</mat-label>
            <textarea
              matInput
              name="observacao"
              [formControl]="produtoPrecoForm.controls['observacao']"
              rows="3"
            ></textarea>
          </mat-form-field>
        </div>
      </div>
    </form>
  </mat-card>
</div>
<mat-dialog-actions>
  <div fxFlex="100" class="mt-1 action-buttons">
    <button
      mat-raised-button
      color="primary"
      [matTooltip]="'Salvar Lançamento'"
      (click)="this.save(); $event.preventDefault()"
    >
      <mat-icon>save</mat-icon> {{ "SAVE" | translate }}
    </button>
    <span fxFlex></span>
    <button mat-button color="warn" type="button" (click)="close()">
      <mat-icon>close</mat-icon> {{ "CLOSE" | translate }}
    </button>
  </div>
</mat-dialog-actions>